import { render, staticRenderFns } from "./businessIndicators.vue?vue&type=template&id=5df83da5&scoped=true"
import script from "./businessIndicators.vue?vue&type=script&lang=js"
export * from "./businessIndicators.vue?vue&type=script&lang=js"
import style0 from "./businessIndicators.vue?vue&type=style&index=0&id=5df83da5&prod&lang=scss&scoped=true"
import style1 from "./businessIndicators.vue?vue&type=style&index=1&id=5df83da5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df83da5",
  null
  
)

export default component.exports